import P from 'components/P';
import FlexChild from 'layouts/flex/FlexChild';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import { useEffect, useState } from 'react';
import { requester } from 'App';
import Container from 'layouts/container/Container';
import Center from 'layouts/wrapper/Center';
import BarChart from 'routes/vendor/chart/BarChart';
import DynamicTable from 'routes/vendor/top5/DynamicTable';
import PartnersSettlementStatus from '../sales/PartnersSettlementStatus';
import { useOutletContext } from 'react-router-dom';

function PartnersSalesStatistics() {
    const [products, setProducts] = useState();
    const [isMounted, setMounted] = useState(false);
    const { stores } = useOutletContext();

    useEffect(() => {
        setMounted(true);
    }, []);
    useEffect(() => {
        if (isMounted) {
            const data = { userId: stores[0]?.vendorId }
            requester.getBestSalesTop5Body(data,result => {
                setProducts(result.data);
            });
        }
    }, [isMounted]);
    return (
        <Container>
            <Container maxWidth={1200}>
                <VerticalFlex gap={50}>
                    <FlexChild width={"90%"}>
                        <Center width={"100%"} textAlign={"left"}>
                            <P weight={'bold'} size={40}>
                                전체매출통계
                            </P>
                        </Center>
                    </FlexChild>
                    <FlexChild width={'90%'}>
                        <PartnersSettlementStatus />
                    </FlexChild>
                    <FlexChild width={'90%'} backgroundColor={"white"} padding={"15px"}>

                        <VerticalFlex>
                            <FlexChild>
                                <P size={24} weight={'bold'}>
                                    상품별 판매량
                                </P>
                            </FlexChild>
                            <FlexChild>
                                <BarChart productData={products && products} />
                            </FlexChild>
                        </VerticalFlex>
                    </FlexChild>
                    <FlexChild>
                        <P weight={'bold'} size={40}>
                            판매량 순위 TOP 5
                        </P>
                    </FlexChild>
                    <FlexChild width={'90%'}>
                        <div style={{ width: '100%' }}>
                            <DynamicTable fetchedData={products && products} />
                        </div>
                    </FlexChild>
                </VerticalFlex>
            </Container>
        </Container>
    );
}

export default PartnersSalesStatistics;
